<div class="analytics-header-section row">
  <div class="col-md-6">
    <div class="analytics-title">BrandCard Analytics</div>
  </div>
  <div class="col-md-6">
    <div class="analytics-timeline">
      <ul class="nav nav-pills" id="chart_tabs">
        <li class="nav-item ml-1">
          <button class="nav-link" [class.active]="active === 'today'" (click)="onChange('today')">Today</button>
        </li>
        <li class="nav-item ml-1">
          <button class="nav-link" [class.active]="active === 'thisWeek'" (click)="onChange('thisWeek')">This Week</button>
        </li>
        <li class="nav-item ml-1">
          <button class="nav-link" [class.active]="active === 'thisMonth'" (click)="onChange('thisMonth')">This Month</button>
        </li>
      </ul>
    </div>
  </div>
</div>
<div>
  <canvas baseChart height="250" [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
  </canvas>
</div>
